const name = 'DATAPERMISSIONTOKEN'

export function setVerifyToken(token) {
  return localStorage.setItem(name, token)
}

export function getVerifyToken() {
  return localStorage.getItem(name)
}
